import { css } from '@emotion/css';

export const breadcrumbStyles = css`
  color: var(--text-primary);
`;

// @lyearn/ui's Breadcrumbs hardcodes a "/" separator with no prop to override it. Mask it into
// the same ArrowIosForward glyph the app's other admin-page breadcrumb already uses (see
// renderBreadcrumbs in modules/corporate/modules/admin/components/Header/Title) — a thinner,
// more open chevron than ChevronRightFill/Outline (which share one chunky, solid-arrow path in
// this icon set) — so both breadcrumb styles match, without touching the shared package or
// disturbing the separator's layout spacing. mask-image (not a text ">") keeps this a crisp
// vector shape instead of a font-dependent glyph, and stays theme-aware via background-color,
// unlike a color baked into the data URI.
const CHEVRON_MASK_URL =
  "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M10 19a1 1 0 01-.64-.23 1 1 0 01-.13-1.41L13.71 12 9.39 6.63a1 1 0 01.15-1.41 1 1 0 011.46.15l4.83 6a1 1 0 010 1.27l-5 6A1 1 0 0110 19z'/%3E%3C/svg%3E\")";

export const breadcrumbsChevronStyles = css`
  .MuiBreadcrumbs-separator {
    color: transparent;
    width: 22px;
    height: 20px;
    background-color: var(--icon-secondary);
    -webkit-mask-image: ${CHEVRON_MASK_URL};
    mask-image: ${CHEVRON_MASK_URL};
    -webkit-mask-size: contain;
    mask-size: contain;
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-position: center;
    mask-position: center;
  }
`;
